import { FETCH_ALL_ADDRESSES_FAILURE, FETCH_ALL_ADDRESSES_REQUEST, FETCH_ALL_ADDRESSES_SUCCESS, } from "../../actions";
const initialState = {
    data: [],
    loading: false,
    error: null,
};
const allAddressesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_ADDRESSES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_ALL_ADDRESSES_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: action.payload, error: null });
        case FETCH_ALL_ADDRESSES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default allAddressesReducer;
